import Vue from 'vue'
import router from './router'
import store from './store'
import vuetify from './vuetify/index'
import App from './views/App'
import permissions from './mixins/Permisssions'
import './axios'
import './filters'
import axios from "axios";

Vue.mixin(permissions)

new Vue({
    el: '#app',
    store,
    router,
    vuetify,
    template: '<App/>',
    components: {App},
    created() {
        // Just after refresh browser

        if (store.getters['loggedIn']) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.token

            store.dispatch('loadUserData').then((response) => {
                store.commit('toggleHeaderVisibility', true)
                store.commit('toggleSiderLeftVisibility', true)
            }).catch((error) => {
                console.log(error)
            })
            /*
            axios.get('api/user/profile')
                .then(
                    (response) => {
                        store.commit('updateProfile', response.data)
                        store.commit('toggleHeaderVisibility', true)
                        store.commit('toggleSiderLeftVisibility', true)
                        _axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.token
                        //resolve(response);
                    }
                )
                .catch(
                    (error) => {
                        // Access denied
                        //reject(error)
                        console.log(error)
                    }
                )
            */
        } else
            console.log('You are logged out.')
    }
});
